import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const PricedUpLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        xmlns='http://www.w3.org/2000/svg'
        width='120'
        height='32'
        fill='none'
        viewBox='0 0 120 32'
        className={className}
    >
        <g clipPath='url(#priced-up-logo-login)'>
            <path
                fill='#14171C'
                d='M12.35 19.973a5.07 5.07 0 0 1-1.405 1.788c-.596.48-1.292.84-2.09 1.079-.797.24-1.651.36-2.564.36H3.575v4.875H0v-16.25h6.639c.975 0 1.845.136 2.612.406.766.271 1.416.655 1.95 1.15a5.029 5.029 0 0 1 1.23 1.775c.287.689.43 1.451.43 2.287v.046c0 .944-.17 1.772-.511 2.484Zm-3.11-2.46c0-.805-.26-1.416-.778-1.834-.519-.418-1.228-.627-2.125-.627H3.575v4.967h2.832c.897 0 1.594-.235 2.09-.707a2.327 2.327 0 0 0 .742-1.753v-.047ZM25.373 28.076l-3.482-5.2h-2.809v5.2h-3.574v-16.25h7.428c1.934 0 3.44.471 4.516 1.416 1.075.944 1.613 2.26 1.613 3.946v.046c0 1.316-.322 2.387-.963 3.215-.643.828-1.482 1.436-2.52 1.823l3.97 5.803h-4.179Zm.07-10.702c0-.774-.247-1.354-.743-1.741s-1.184-.58-2.066-.58H19.08v4.665h3.622c.882 0 1.56-.208 2.031-.627.473-.418.708-.975.708-1.671v-.046h.001ZM32.453 28.076v-16.25h3.575v16.25h-3.575ZM53.068 26.66a7.626 7.626 0 0 1-3.227 1.497 10.58 10.58 0 0 1-2.136.197c-1.192 0-2.298-.216-3.32-.65a8.155 8.155 0 0 1-2.646-1.776 8.08 8.08 0 0 1-1.742-2.659 8.563 8.563 0 0 1-.626-3.273v-.046c0-1.162.209-2.248.626-3.262a8.393 8.393 0 0 1 1.742-2.67 8.076 8.076 0 0 1 2.67-1.811c1.036-.442 2.182-.662 3.435-.662.758 0 1.452.062 2.078.186a8.69 8.69 0 0 1 1.707.511c.51.217.982.48 1.415.79.434.31.836.65 1.208 1.02l-2.275 2.624a8.633 8.633 0 0 0-1.94-1.347c-.657-.325-1.396-.488-2.216-.488a4.495 4.495 0 0 0-3.389 1.485 5.084 5.084 0 0 0-.975 1.614 5.483 5.483 0 0 0-.348 1.961v.047c0 .696.116 1.354.348 1.973.232.619.553 1.16.963 1.625a4.47 4.47 0 0 0 3.4 1.51c.93-.001 1.715-.171 2.358-.511.641-.34 1.28-.805 1.915-1.393l2.274 2.298c-.417.449-.85.851-1.3 1.207v.002ZM57.227 28.076v-16.25H69.46v3.18h-8.705v3.296h7.661v3.18h-7.661v3.413h8.821v3.18h-12.35ZM87.125 23.154a7.554 7.554 0 0 1-1.777 2.576c-.766.728-1.68 1.3-2.739 1.718-1.06.418-2.225.626-3.494.626h-6.338V11.825h6.338c1.27 0 2.434.206 3.494.616 1.06.41 1.974.978 2.74 1.706a7.62 7.62 0 0 1 1.776 2.565c.418.983.626 2.047.626 3.192v.047a8.159 8.159 0 0 1-.626 3.203Zm-3.11-3.204c0-.712-.12-1.37-.36-1.973a4.641 4.641 0 0 0-.999-1.556 4.43 4.43 0 0 0-1.543-1.01 5.355 5.355 0 0 0-1.997-.36h-2.762v9.797h2.762c.727 0 1.393-.116 1.997-.348a4.284 4.284 0 0 0 1.543-.997 4.69 4.69 0 0 0 .998-1.533c.24-.588.36-1.245.36-1.973v-.047Z'
            />
            <path
                fill='#F2C300'
                d='M94.034 10.698v9.657c0 2.508 1.266 3.698 3.202 3.698s3.228-1.142 3.228-3.574v-9.781h4.866l-8.081-7.832-8.081 7.832h4.866Z'
            />
            <path
                fill='#F2C300'
                d='M112.801 10.697h-7.473v9.633c0 4.443-2.031 6.917-5.347 7.746h10.163V23.11h2.408c4.295 0 7.448-2.16 7.448-6.281v-.05c0-3.823-2.831-6.083-7.199-6.083Zm2.408 6.356c0 1.366-1.068 2.284-2.755 2.284h-2.309v-4.594h2.284c1.713 0 2.781.77 2.781 2.26v.049h-.001Z'
            />
        </g>
        <defs>
            <clipPath id='priced-up-logo-login'>
                <path
                    fill='#fff'
                    d='M0 2.866h120v25.488H0z'
                />
            </clipPath>
        </defs>
    </SvgElement>
);
